module.exports = __webpack_public_path__ + "img/Barometro.3c73d19f.svg";